import api from './api';

// 크롤링 API 함수들
const crawlApi = {
  // 크롤링 시작
  startCrawl: async (crawlData) => {
    const response = await api.post('/crawl', crawlData);
    return response.data;
  },
  
  // 크롤링 상태 확인
  getCrawlStatus: async (crawlId) => {
    const response = await api.get(`/crawl/${crawlId}`);
    return response.data;
  },
  
  // 크롤링 작업 목록 가져오기
  listCrawls: async () => {
    const response = await api.get('/crawl');
    return response.data;
  },
  
  // 크롤링 작업 취소
  cancelCrawl: async (crawlId) => {
    const response = await api.delete(`/crawl/${crawlId}`);
    return response.data;
  },
  
  // 크롤링 작업 완전 삭제 (파일 포함)
  deleteCrawl: async (crawlId) => {
    const response = await api.delete(`/crawl/${crawlId}/delete`);
    return response.data;
  },
  
  // 크롤링 작업 재시작
  restartCrawl: async (crawlId) => {
    const response = await api.post(`/crawl/${crawlId}/restart`);
    return response.data;
  },

  // 크롤링 작업을 수동으로 완료로 표시
  markAsCompleted: async (crawlId) => {
    const response = await api.put(`/crawl/${crawlId}/complete`);
    return response.data;
  }
};

export default crawlApi; 